import React, { useState, useEffect } from 'react';
import { Header, Icon, Loader } from 'semantic-ui-react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useTaskContext } from './context/TaskContext';
import * as api from './services/api';

const TaskListsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
`;

const TaskListRect = styled.div`
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 0.5em;
  cursor: pointer;
  transition: box-shadow 0.2s, background 0.2s;
  min-width: 70px;

  &:hover {
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    background: #ebebeb;
  }
`;

const TaskListLabel = styled.div`
  font-size: 0.7em;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
  margin-bottom: 0.35em;
`;

const TaskSquaresContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
`;

const TaskSquare = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: ${props => props.$complete ? '#333' : 'transparent'};
  border: 1.5px solid ${props => props.$complete ? '#333' : '#ccc'};
`;

const AssignedTaskList = () => {
  const [taskLists, setTaskLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { loadTask } = useTaskContext();

  useEffect(() => {
    const fetchAssigned = async () => {
      try {
        const data = await api.getAssignedToMe();
        setTaskLists(data);
      } catch (error) {
        console.error('Error fetching assigned tasks:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchAssigned();
  }, []);

  const handleTaskListClick = (parentUuid) => {
    navigate(`/?p=${parentUuid}`);
    loadTask(parentUuid);
  };

  if (loading) {
    return <Loader active>Loading assigned tasks...</Loader>;
  }

  return (
    <div>
      <Header as='h2'>
        <Icon>
          <img src="responsibility.svg" alt="Assigned" style={{ width: '32px', height: '32px' }} />
        </Icon>
        <Header.Content>Assigned</Header.Content>
      </Header>
      {taskLists.length > 0 ? (
        <TaskListsContainer>
          {taskLists.map(taskList => (
            <TaskListRect
              key={taskList.parentUuid}
              onClick={() => handleTaskListClick(taskList.parentUuid)}
            >
              <TaskListLabel title={taskList.parentLabel}>
                {taskList.parentLabel}
              </TaskListLabel>
              <TaskSquaresContainer>
                {taskList.tasks.map(task => (
                  <TaskSquare
                    key={task.uuid}
                    $complete={task.status === 2}
                  />
                ))}
              </TaskSquaresContainer>
            </TaskListRect>
          ))}
        </TaskListsContainer>
      ) : (
        <p>No assigned tasks.</p>
      )}
    </div>
  );
};

export default AssignedTaskList;
